import { Injectable } from '@angular/core';
import CryptoES from 'crypto-es'
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  cryptoKey: CryptoES.lib.WordArray;
  cryptoIv: CryptoES.lib.WordArray;

  constructor() {
    this.cryptoKey = CryptoES.enc.Base64.parse("R4YT5YLzLdBJE2Ecuz+szulZHsJ+FGKDZasicEvLjO8=");
    this.cryptoIv = CryptoES.enc.Base64.parse("IWFvbR1NouI693AnbARpgg==");
  }

  encrypt(plainText: string) {
    try
    {
      return CryptoES.AES.encrypt(plainText, this.cryptoKey, {
        iv: this.cryptoIv
      }).toString();
    }
    catch (error)
    {
      return "";
    }
  }

  decrypt(ciphertext: string | CryptoES.lib.CipherParams) {
    if(!ciphertext) return "";
    try
    {
      return CryptoES.AES.decrypt(ciphertext, this.cryptoKey, {
        iv: this.cryptoIv
      }).toString(CryptoES.enc.Utf8);
    }
    catch (error)
    {
      return "";
    }    
  }

  decode(encodedText: string)
  {
    let parsedWordArray = CryptoES.enc.Base64.parse(encodedText);
    return parsedWordArray.toString(CryptoES.enc.Utf8);
  }

  fromSafeBase64(url: string): string {
    return url.replace("_", "/").replace("-", "+");
  }

  getDecodedAccessToken(): any {
    try{
      let token = localStorage.getItem("token");
      if(token)
        return jwt_decode(token);
      return null;
    }
    catch(err){
        return null;
    }
  }
}
